'use strict';

var Rate = require('./src/Rate.js');



exports.Rate = Rate.Rate;
//# sourceMappingURL=index.js.map
